"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _appendCss = _interopRequireDefault(require("../utils/appendCss"));
var _porg = _interopRequireDefault(require("../assets/porg.png"));
var _Table_css = _interopRequireDefault(require("./Table_css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
class Table extends _react.Component {
  constructor() {
    super();
    (0, _defineProperty2.default)(this, "getBeginDataIndex", () => {
      const {
        data,
        renderedRowCount
      } = this.props;
      const rowsBeforeBuffer = 2; // ensures rows are available when scrolling up quickly

      let beginDataIndex = this.state.rowsBefore - rowsBeforeBuffer;
      if (beginDataIndex < 0) beginDataIndex = 0;else {
        const hiddenRowCount = data.length - renderedRowCount;
        if (beginDataIndex > hiddenRowCount) {
          beginDataIndex = hiddenRowCount < 0 ? 0 : hiddenRowCount;
        }
      }
      return beginDataIndex;
    });
    (0, _defineProperty2.default)(this, "getEndDataIndex", beginDataIndex => {
      const {
        data,
        renderedRowCount
      } = this.props;
      let endDataIndex = beginDataIndex + renderedRowCount;
      if (endDataIndex > data.length) endDataIndex = data.length;
      return endDataIndex;
    });
    // for calculating heights of presentation rows
    // to preserve proper scrollbar height
    (0, _defineProperty2.default)(this, "setRowsBefore", () => {
      let rowsBefore = Math.floor(this.tableBodyWrapper.scrollTop / (this.props.bodyRowHeight + 1));
      if (this.state.rowsBefore !== rowsBefore) this.setState({
        rowsBefore
      });
    });
    // Adjusts for scrollbar to ensure body's columns line up with header's
    (0, _defineProperty2.default)(this, "setTableBodyWidthDifference", () => {
      const {
        data,
        hideHeader
      } = this.props;
      if (!hideHeader && data.length > 0) {
        const tableBodyWidth = this.tableBody.getBoundingClientRect().width;
        const tableHeaderWidth = this.tableHeader.getBoundingClientRect().width;
        const widthOffset = tableHeaderWidth - tableBodyWidth;
        if (widthOffset !== 0) {
          const {
            tableBodyWidthDifference
          } = this.state;
          this.setState({
            tableBodyWidthDifference: tableBodyWidthDifference + widthOffset
          });
        }
      }
    });
    (0, _appendCss.default)("arc_table", _Table_css.default);
    this.tableBody = /*#__PURE__*/_react.default.createRef();
    this.tableBodyWrapper = /*#__PURE__*/_react.default.createRef();
    this.tableHeader = /*#__PURE__*/_react.default.createRef();
    this.state = {
      rowsBefore: 0,
      tableBodyWidthDifference: 0
    };
  }
  componentDidMount() {
    this.setTableBodyWidthDifference();
    this.setRowsBefore();
    window.addEventListener("resize", this.setTableBodyWidthDifference);
  }
  componentDidUpdate(prevProps) {
    const {
      data
    } = this.props;
    const prevLength = prevProps.data.length;
    if (prevLength !== data.length) {
      this.setTableBodyWidthDifference();
    }
    if (prevProps.data !== data) {
      if (this.tableBodyWrapper) {
        this.tableBodyWrapper.scrollTop = 0;
      }
    }
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.setTableBodyWidthDifference);
  }
  render() {
    const {
      bodyRowHeight,
      columnKey,
      className,
      columnProps,
      data,
      headerRowClass,
      headerRowHeight,
      hideHeader,
      noResultsMessage,
      onRowClick,
      setBodyRowClass,
      setCellClass,
      setRowDataQA
    } = this.props;
    const beginDataIndex = this.getBeginDataIndex();
    const endDataIndex = this.getEndDataIndex(beginDataIndex);
    const renderedData = data.slice(beginDataIndex, endDataIndex);

    // Two tables are used to allow fixed headers and scrolling body
    return /*#__PURE__*/_react.default.createElement("div", {
      className: `table__wrapper ${className}`
    }, !hideHeader && /*#__PURE__*/_react.default.createElement("table", {
      cellPadding: 0,
      className: "table__sub-table",
      ref: node => {
        this.tableHeader = node;
      }
    }, /*#__PURE__*/_react.default.createElement("thead", {
      className: "table__header"
    }, /*#__PURE__*/_react.default.createElement("tr", {
      className: `table__row--header ${headerRowClass}`
    }, Object.keys(columnProps).map(column => /*#__PURE__*/_react.default.createElement("th", {
      key: column,
      className: "table__cell t-label-large",
      style: {
        height: `${headerRowHeight}px`,
        width: columnProps[column].width
      }
    }, typeof columnProps[column].header === "function" ? columnProps[column].header(headerRowHeight) : /*#__PURE__*/_react.default.createElement("span", {
      className: "table__content",
      style: {
        lineHeight: `${headerRowHeight}px`
      }
    }, columnProps[column].header)))))), renderedData.length > 0 ? /*#__PURE__*/_react.default.createElement("div", {
      className: `table__wrapper--body${hideHeader ? " hide-header" : ""}`,
      onScroll: this.setRowsBefore,
      ref: node => {
        this.tableBodyWrapper = node;
      },
      style: {
        height: `calc(100% - ${headerRowHeight}px)`
      }
    }, /*#__PURE__*/_react.default.createElement("table", {
      cellPadding: 0,
      className: "table__sub-table--body",
      style: {
        width: `calc(100% + ${this.state.tableBodyWidthDifference}px)`
      },
      ref: node => {
        this.tableBody = node;
      }
    }, /*#__PURE__*/_react.default.createElement("tbody", {
      className: "table__body"
    }, /*#__PURE__*/_react.default.createElement("tr", {
      role: "presentation",
      style: {
        height: `${beginDataIndex * (bodyRowHeight + 1)}px`
      }
    }, Object.keys(columnProps).map(column => /*#__PURE__*/_react.default.createElement("td", {
      key: column,
      className: "table__cell t-body-med",
      style: {
        width: columnProps[column].width
      }
    }, /*#__PURE__*/_react.default.createElement("div", null)))), renderedData.map((row, i) => /*#__PURE__*/_react.default.createElement("tr", {
      key: row[columnKey] || i,
      "data-qa": setRowDataQA(row),
      className: `table__row--body ${setBodyRowClass(row, i)}`,
      onClick: () => {
        onRowClick(row, i);
      },
      style: {
        height: `${bodyRowHeight}px`
      }
    }, Object.keys(columnProps).map((column, j) => /*#__PURE__*/_react.default.createElement("td", {
      key: column,
      className: `table__cell t-body-med ${setCellClass(row, column, i, j)}`,
      style: {
        width: columnProps[column].width
      }
    }, columnProps[column].render ? columnProps[column].render(row, column) : /*#__PURE__*/_react.default.createElement("span", {
      className: "table__content",
      style: {
        lineHeight: `${bodyRowHeight}px`
      }
    }, row[column]))))), /*#__PURE__*/_react.default.createElement("tr", {
      style: {
        height: `${(data.length - endDataIndex) * (bodyRowHeight + 1)}px`
      }
    }, Object.keys(columnProps).map(column => /*#__PURE__*/_react.default.createElement("td", {
      key: column,
      className: "table__cell t-body-med",
      style: {
        width: columnProps[column].width
      }
    }, /*#__PURE__*/_react.default.createElement("div", null))))))) : /*#__PURE__*/_react.default.createElement("div", {
      className: "table__no-results"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "table__no-results-message t-label-large"
    }, noResultsMessage), /*#__PURE__*/_react.default.createElement("img", {
      src: _porg.default,
      alt: "no results"
    })));
  }
}
Table.propTypes = {
  /** how many pixels tall each body row should be */
  bodyRowHeight: _propTypes.default.number.isRequired,
  /** additional CSS for the table */
  className: _propTypes.default.string,
  /** column where data to use as key for row is present */
  columnKey: _propTypes.default.string,
  /** Info for each table column.
   * Header: What should appear in the header cell for a column , you can pass a string or a function that returns jsx.
   * Render: How to render a column cell.
   * Width: How wide should the column be.
   * */
  columnProps: _propTypes.default.shape({
    header: _propTypes.default.string,
    render: _propTypes.default.func,
    width: _propTypes.default.string
  }).isRequired,
  /** data to populate table cells */
  data: _propTypes.default.array.isRequired,
  /** additional CSS for the table header */
  headerRowClass: _propTypes.default.string,
  /** how many pixels tall header row should be; if absent, uses bodyRowHeight instead */
  headerRowHeight: _propTypes.default.number,
  /** specifies whether header is hidden */
  hideHeader: _propTypes.default.bool,
  /** message to display when no data for table */
  noResultsMessage: _propTypes.default.string,
  /** handler for when a row is clicked */
  onRowClick: _propTypes.default.func,
  /** number of rows to render, recommended to be at least 4 above what is actually visible */
  renderedRowCount: _propTypes.default.number.isRequired,
  /** a function describing how a CSS class should be applied to a row */
  setBodyRowClass: _propTypes.default.func,
  /** a function describing how a CSS class should be applied to a cell */
  setCellClass: _propTypes.default.func,
  /** a function allowing for a data QA attribute to be applied to a row */
  setRowDataQA: _propTypes.default.func
};
Table.defaultProps = {
  className: "",
  headerRowClass: "",
  hideHeader: false,
  noResultsMessage: "Uh oh! We couldn't find any results for that...",
  onRowClick: () => {},
  setBodyRowClass: () => "",
  setCellClass: () => "",
  setRowDataQA: () => ""
};
var _default = exports.default = Table;